export const CAREER_FUNNEL_STEP = 'analytics/CAREER_FUNNEL_STEP';
export const CAREER_FUNNEL_EXIT = 'analytics/CAREER_FUNNEL_EXIT';
export const CAREER_MARKET_STEP = 'analytics/CAREER_MARKET_STEP';
export const CAREER_MARKET_EXIT = 'analytics/CAREER_MARKET_EXIT';

export default function(type, args) {
    return Object.assign({ type }, args);
}



// WEBPACK FOOTER //
// ./analytics-actions.js